import styled, { css } from 'styled-components';

interface ToggleChatProps {
  isActive: boolean;
  hasNewMessage: boolean;
}

export const Container = styled.div`
  display: flex;

  width: 100%;
  height: calc(100vh - 75px);
  padding: 0 10px;

  > div {
    display: flex;
    flex-direction: column;

    width: 100%;
    max-width: 900px;
    height: min-content;

    > h1 {
      padding-bottom: 1rem;
    }

    @media screen and (max-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
      padding: 20px;
    }
  }
`;

export const LocalVideoContainer = styled.div`
  position: relative;

  background: ${({ theme }) => theme.colors.graySecondaryDark};
  border-radius: 5px 5px 0 0;
  height: min-content;
  width: 100%;
`;

export const RemoteVideoContainer = styled.div<{ canHide: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  height: min-content;
  min-height: 140px;
  width: 100%;

  ${({ canHide }) =>
    canHide &&
    css`
      @media screen and (max-width: ${({ theme }) =>
          theme.gridBreakpoints.sm}) {
        display: none;
      }
    `}
`;

export const MainArea = styled.div<{ chatVisible: boolean }>`
  display: grid;
  grid-template-columns: 1fr 2fr;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 20px;

  height: 100%;
  width: 100%;
  max-width: 800px;
  position: absolute;
  top: 0;
  padding: 20px;

  @media screen and (max-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
    grid-template-columns: 1fr;

    position: relative;

    padding: ${({ chatVisible }) => (chatVisible ? '20px' : '0')};
  }
`;

export const ControlsArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  gap: 1.5rem;

  width: 100%;
  background-color: ${({ theme }) => theme.colors.graySecondaryLight};
  border-radius: 0 0 5px 5px;
  padding: 20px 0;

  svg {
    width: 30px;
    height: 30px;
  }

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media screen and (max-width: ${({ theme }) => theme.gridBreakpoints.md}) {
    button {
      padding: 10px;
      min-width: 70px;
    }

    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
    button {
      padding: 8px;
      min-width: 40px;
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }

  @media screen and (max-width: 420px) {
    grid-template-columns: 4fr 1fr;
    gap: 0.5rem;

    > div {
      padding-left: 10px;

      &:first-child {
        display: none;
      }
    }
  }
`;

export const ToggleChat = styled.button<ToggleChatProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  background: none;
  border: none;
  height: min-content;
  margin: auto;
  position: relative;
  height: min-content;
  width: min-content;
  padding: 10px;

  > svg > path {
    color: ${({ theme, isActive }) =>
      isActive ? '#fff' : theme.colors.graySecondaryDark};
  }

  ${({ hasNewMessage, theme }) =>
    hasNewMessage &&
    css`
      &::after {
        content: '';
        position: absolute;
        width: 15px;
        height: 15px;
        background: ${theme.colors.warning};
        border-radius: 50%;
        margin-left: 25px;
        margin-bottom: 25px;

        @media screen and (max-width: ${theme.gridBreakpoints.sm}) {
          width: 10px;
          height: 10px;
          margin-left: 15px;
          margin-bottom: 15px;
        }
      }
    `};

  @media screen and (max-width: ${({ theme }) => theme.gridBreakpoints.md}) {
    right: 2rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
    position: initial;
  }
`;

export const NoVideo = styled.div<{ videoType: 'local' | 'remote' }>`
  display: flex;
  justify-content: center;
  align-items: center;

  background: ${({ theme }) => theme.colors.graySecondaryDark};
  width: 100%;
  height: 400px;

  span {
    color: #fff;
    text-align: center;
  }

  ${({ videoType }) =>
    videoType === 'local' &&
    css`
      border-radius: 5px 5px 0 0;
    `};

  @media screen and (min-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
    ${({ videoType }) =>
      videoType === 'local'
        ? css`
            height: 400px;
          `
        : css`
            height: 140px;
            border-radius: 5px;
            border: 1px solid #fff;
          `};
  }

  @media screen and (max-width: 420px) {
    height: 250px;
  }
`;
